import React from 'react';
import { Provider } from "react-redux";

import store from "./store";

import Admin from './Components/admin';
import User from './Components/user';

const App = () => {
    const { location: { pathname } } = window;
    const component = pathname.match(/^\/admin/) ? <Admin /> : <User />;

    return (
        <Provider store={store}>
            <div className="App">{component}</div>
        </Provider>
    );
};

export default App;
